<template>
  <div id="app">
    <!-- <Nav></Nav> -->
    <MixHeader></MixHeader>
    <!-- <transition name="fade" mode="out-in"> -->
      <router-view></router-view>
    <!-- </transition> -->

    <MixFooter></MixFooter>
  </div>
</template>

<script>
import MixHeader from '@/components/header/mixHeader.vue'
import MixFooter from '@/components/footer/mixFooter.vue'
import Nav from '@/components/header/nav.vue'



export default {
  name: 'app',
  components:{
    MixHeader,
    MixFooter,
    Nav,
  }
}
</script>


<style >
*{
  margin: 0;
  padding: 0;
}
html, body {
  overflow-x: hidden; /* 强制隐藏横向滚动条 */
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;  
}

a{
  text-decoration: none;
}

.main-flex{
	display: flex;
	justify-content: center;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity 1s;
  }
.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>
